<template>
    <group-backend-layout page-title="Payment History">
        <div v-if="invoices.length" class="datatable-theme">
            <easy-data-table
                class="table"
                :headers="headers"
                :items="invoices"
                :hide-footer="invoices.length <= 10"
                :rows-per-page="10"
                :rows-items="[10, 25, 50]"
                buttons-pagination
                empty-message="No invoices"
                must-sort
            >
                <template #item-paid_at="invoice">
                    {{
                        dayjs(invoice.paid_at)
                            .utc(true)
                            .tz($page.props.auth.user.timezone)
                            .format($page.props.date_formats.short_nice)
                    }}
                </template>
                <template #item-invoice_items="invoice">
                    <span v-html="membershipsPurchasedCount(invoice)"></span>
                </template>
                <template #item-user.full_name="invoice">
                    <span class="whitespace-nowrap">
                        {{ invoice.user.full_name }}
                    </span>
                </template>
                <template #item-subtotal="invoice">
                    <value-as-currency :value="invoice.subtotal" />
                </template>
                <template #item-discount_details="invoice">
                    <value-as-currency
                        :value="invoice.discount_details.total"
                    />

                    <span
                        class="ml-2 rounded bg-gray-350 px-1 py-1 text-[14px] text-gray-800"
                    >
                        {{ invoice.discount_details.percent }}%</span
                    >
                </template>
                <template #item-total="invoice">
                    <value-as-currency :value="invoice.total_usd" />
                </template>
                <template #item-actions="invoice">
                    <a
                        class="link"
                        :href="
                            route('show-invoice', {
                                invoice_uuid: invoice.uuid,
                            })
                        "
                        target="_blank"
                        >Receipt
                    </a>
                </template>
            </easy-data-table>
        </div>
        <div v-else class="rounded border-gray-450 bg-gray-250 p-8 text-center">
            <div class="mb-4 text-[18px] font-semibold">
                No payments records available
            </div>
            <div v-if="group.owner_id === $page.props.auth.user.id">
                No payments exist for this organization. As the owner of
                <span class="font-semibold">{{ group.name }}</span> you will see
                all payments made by admins of this group here.
            </div>
            <div v-else>
                You have made no payments as a member of this group. You will
                only be able to see your own payments here unless you are the
                organization owner. The organization owner for
                {{ group.name }}
                is
                <span class="font-semibold">{{ group.owner.full_name }}</span>
            </div>
        </div>
    </group-backend-layout>
</template>

<script>
import GroupBackendLayout from "@/_Layouts/GroupBackendLayout";

import DataTable from "datatables.net-vue3";
import DataTablesLib from "datatables.net";
import DataTablesResponsive from "datatables.net-responsive";
import ValueAsCurrency from "@/Components/ValueAsCurrency";

DataTable.use(DataTablesLib);

export default {
    name: "GroupPaymentHistory",
    components: {
        ValueAsCurrency,
        GroupBackendLayout,
        DataTable,
        DataTablesResponsive,
    },
    props: {
        group: {
            type: Object,
            default: {},
        },
        invoices: {
            type: Array,
            default: [],
        },
    },
    data() {
        return {
            headers: [
                {
                    text: "Date Purchased",
                    value: "paid_at",
                },
                {
                    text: "# of Memberships",
                    value: "invoice_items",
                    class: "text-gray-750",
                },
                {
                    text: "Purchased By",
                    value: "user.full_name",
                    class: "text-gray-750",
                },
                {
                    text: "Subtotal",
                    value: "subtotal",
                    class: "text-gray-750",
                },
                {
                    text: "Discount",
                    value: "discount_details",
                    class: "text-gray-750",
                },
                {
                    text: "Total",
                    value: "total",
                },
                {
                    text: "",
                    value: "actions",
                    sort: false,
                },
            ],
        };
    },
    methods: {
        membershipsPurchasedCount(invoice) {
            return (
                _.sumBy(invoice.invoice_items, function (item) {
                    return item.qty;
                }) + "&nbsp;memberships"
            );
        },
    },
};
</script>

<style scoped></style>
